import { getCheckoutApiBaseUrl } from './loadConfig.js';

export async function createAcquisitionFormDonor(acquisitionFormId, payload, captchaToken = null) {
  return request(`/v1/acquisitionforms/${acquisitionFormId}/submissions`, {
    method: 'POST',
    headers: captchaHeaders(captchaToken),
    body: JSON.stringify(payload)
  });
}

export async function updateAcquisitionFormDonor(submissionId, payload, captchaToken = null) {
  return request(`/v1/acquisitionforms/submissions/${submissionId}/donor`, {
    method: 'PUT',
    headers: captchaHeaders(captchaToken),
    body: JSON.stringify(payload)
  });
}

export async function submitAcquisitionFormDonation(submissionId, payload, captchaToken = null) {
  return request(`/v1/acquisitionforms/submissions/${submissionId}/donation`, {
    method: 'POST',
    headers: captchaHeaders(captchaToken),
    body: JSON.stringify(payload)
  });
}

export async function updateAcquisitionFormDonation(submissionId, payload, captchaToken = null) {
  return request(`/v1/acquisitionforms/submissions/${submissionId}/donation`, {
    method: 'PUT',
    headers: captchaHeaders(captchaToken),
    body: JSON.stringify(payload)
  });
}

export async function getAcquisitionFormChargeResult(submissionId) {
  return request(`/v1/acquisitionforms/submissions/${submissionId}/charge-result`);
}

export async function getAddressByZipCode(zipCode) {
  return request(`/v1/addresses/${zipCode}`);
}

function captchaHeaders(captchaToken) {
  return captchaToken ? { 'X-Captcha-Token': captchaToken } : {};
}

async function request(path, options = {}) {
  const baseUrl = getCheckoutApiBaseUrl();
  if (!baseUrl) {
    throw new Error('AcquisitionForm API base URL not configured or detected');
  }

  const response = await fetch(`${baseUrl.replace(/\/$/, '')}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }
  });

  if (!response.ok) {
    let message = `AcquisitionForm API request failed with status ${response.status}`;
    try {
      const error = await response.json();
      message = error.error || error.Error || message;
    } catch { /* empty */ }

    const requestError = new Error(message);
    requestError.status = response.status;
    throw requestError;
  }

  if (response.status === 204 || response.status === 202) {
    return null;
  }

  return response.json();
}
